<script>
import Alert from "@/components/molecules/alert";

export default {
  name: "PaymentMethodMultiPayError",
  components: {
    Alert
  },
  props: {
    error: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    errorDetails() {
      const messages = [];
      if (this.error.errors) {
        const errorsEntries = Object.entries(this.error.errors);
        for (const [, values] of errorsEntries) {
          if (Array.isArray(values)) {
            values.forEach((value) => {
              messages.push(value);
            });
          }
        }
      }
      return messages;
    }
  }
};
</script>

<template>
  <Alert
    has-icon
    icon-size="sm"
    icon-color="alert"
    icon-name="alert-circle-outline"
    icon-position="left-top"
  >
    <span class="u-font-700 u-color-alert">{{ error.message }}</span>
    <p
      v-if="errorDetails.length > 0"
      class="u-color-black u-mt-xxs"
    >
      <span
        v-for="(message, index) in errorDetails"
        :key="`${index}-error-multipay`"
      >
        {{ message }}
        <br v-if="index !== errorDetails.length -1" />
      </span>
    </p>
  </Alert>
</template>
